import { render, staticRenderFns } from "./stamps.vue?vue&type=template&id=307eba5a&"
import script from "./stamps.vue?vue&type=script&lang=js&"
export * from "./stamps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports